import axios from 'axios'
import store from '@/store'

export default () => {
  return axios.create({
    baseURL: process.env.VUE_APP_API,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
      Authorization: `Bearer ${store.getters['auth/user'] ? store.getters['auth/user'].access_token : ''}`,
      'X-USER-ID': store.getters['auth/user'] ? store.getters['auth/user'].user.id : '',
      'Content-Type': 'application/json',
      'client-sender-id': '591b8118-6f52-4654-b21c-6cdb2a5238d7'
    }
  })
}
